import styled from 'styled-components'
import { isProduction } from '@/config/environment.config'

const BAR_HEIGHT = '28px'

const EnvironmentBarStyle = styled.div`
  .env-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: #1558d6;
    color: #fff;
    font-family: "Poppins";
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .04em;
    line-height: ${BAR_HEIGHT};
    height: calc(${BAR_HEIGHT} + env(safe-area-inset-bottom, 0px));
    padding-bottom: env(safe-area-inset-bottom, 0px);
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-inline: 12px;
  }

  .env-bar-detail {
    font-weight: 400;
    opacity: .85;
  }

  /* En movil no cabe la linea entera: se cae lo prescindible antes de que el
     texto se corte. */
  @media (max-width: 520px) {
    .env-bar-extra {
      display: none;
    }
  }

  @media (max-width: 380px) {
    .env-bar {
      font-size: 11px;
      letter-spacing: 0;
    }
  }

  /* La barra es fija: este hueco evita que tape el final de la pagina (en
     movil, el boton de "Encargar YA"). */
  .env-bar-spacer {
    height: calc(${BAR_HEIGHT} + env(safe-area-inset-bottom, 0px));
  }

  @media print {
    .env-bar, .env-bar-spacer {
      display: none;
    }
  }
`

/**
 * Aviso permanente de que la build NO es de produccion. Solo se pinta fuera de
 * produccion, asi que en los tenants de pro no existe ni en el DOM.
 */
export function EnvironmentBarComponent (): JSX.Element | null {
  if (isProduction()) {
    return null
  }

  const tenant = process.env.REACT_APP_LAYOUT ?? 'hospitales'
  const version = process.env.REACT_APP_VERSION ?? ''

  return (
    <EnvironmentBarStyle>
      <div className='env-bar-spacer' />
      <div className='env-bar'>
        ENTORNO DE DESARROLLO{' '}
        <span className='env-bar-detail'>
          · {tenant}{version !== '' ? ` · v${version}` : ''}
          <span className='env-bar-extra'> · datos de prueba</span>
        </span>
      </div>
    </EnvironmentBarStyle>
  )
}
